var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMinusRing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#83868A",
  d: "M16 2C8.277 2 2 8.277 2 16s6.277 14 14 14 14-6.277 14-14S23.723 2 16 2m0 25.2C9.828 27.2 4.8 22.172 4.8 16S9.828 4.8 16 4.8 27.2 9.828 27.2 16 22.172 27.2 16 27.2"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12.444,
  height: 3.111,
  x: 9.781,
  y: 14.444,
  fill: "#83868A",
  rx: 1.556
})));
export default SvgIcMinusRing;